import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { applicationConstants } from 'src/app/constants';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { PreQualData } from 'src/app/model/pre-qual-data.model';
import { PREQUAL_INDICATOR, SWITCH_INDICATOR } from './indicator_json';
declare var $: any;

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {
  currentLang: string;
  sidebarTitle: string;
  progressPercentage: any;
  tabindex: number = -1;
  showSidebar: boolean = true;
  isIos: boolean;
  iosValidios: any;
  counti: string;
  isRequestCallback: boolean;
  indicator: any;
  prequalType = 'P';
  switchType = 'S';
  referral: any;

  constructor(private i18nService: I18nService, private utilService: UtilService, private _router: Router, private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) {
    var userAgent = window.navigator.userAgent;

    this._router.events.pipe(
      filter(event => event instanceof NavigationStart),
    ).subscribe((event: NavigationStart) => {
      if (event && event.url && event.url.includes("request-callback")) {
        this.isRequestCallback = true;
      }
      else {
        this.isRequestCallback = false
      }
    });
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (window.navigator.userAgent.indexOf("Mac") != -1) {
      this.iosValidios = "IOS"
    }

  }
  ngOnInit(): void {
    this.currentLang = this.i18nService.getCurrentLang();
    this.utilService.sidebarTitle.subscribe(val => {
      this.showSidebar = false;
      this.sidebarTitle = val;
      let counti = sessionStorage.getItem("counti");

      this.counti = counti;
      this.showSidebar = true;

    })

    this.utilService.progressPercent.subscribe(val => {
      this.progressPercentage = val;
    })
    this.activatedRoute.queryParams.subscribe(params => {
      this.referral = this.utilService.getReferral(params);
    });
    this.utilService.SIDE_BAR_EVENT.subscribe(url => {
      let curPreQual: PreQualData = this.utilService.getSessionStorage();
      let urlLen = url.split("/").length - 1;
      let curRoute = url.split("/")[urlLen];
      let curIndicatorObj: any;
      console.log(' prequal Data --- > ', curPreQual);
      if (curPreQual) {
        if (curPreQual.flow_type == this.prequalType) {
          this.indicator = PREQUAL_INDICATOR;
          if (this.referral) {
            curRoute = curRoute.split('?')[0];
          }

        }

        else {
          this.indicator = SWITCH_INDICATOR;
          curRoute = curRoute.split('?')[0];
        }

        curIndicatorObj = this.indicator.ONE_NEW_CUSTOMER;
        if (curPreQual.is_coapplicant_applied == 'Y' && curPreQual.are_both_applicants_CIBC_customer == 'Y') {
          curIndicatorObj = this.indicator.TWO_EXISTING_CUSTOMER
        }
        else if (curPreQual.is_coapplicant_applied == 'Y' && curPreQual.are_both_applicants_CIBC_customer == 'N' && curPreQual.is_existing_bankcustomers == 'Y') {
          curIndicatorObj = this.indicator.ONE_NEW_ONE_EXISTING_CUSTOMER;
        }
        else if (curPreQual.is_coapplicant_applied == 'Y' && curPreQual.are_both_applicants_CIBC_customer == 'N' && curPreQual.is_existing_bankcustomers == 'N') {
          curIndicatorObj = this.indicator.TWO_NEW_CUSTOMER;
        }
        else if (curPreQual.is_coapplicant_applied == 'N' && curPreQual.is_existing_bankcustomers == 'Y') {
          curIndicatorObj = this.indicator.ONE_EXISTING_CUSTOMER;
        }
        let dispIndatorObj = curIndicatorObj.filter(obj => curRoute == (obj.routerName));
        this.utilService.currentPageName = curRoute;
        if (dispIndatorObj.length > 0) {
          this.progressPercentage = dispIndatorObj[0].displayPercentage;
          this.sidebarTitle = dispIndatorObj[0].indicatorTitle;
          this.showSidebar = true;
          if (document.getElementById("sidebarTitle")) {
            document.getElementById('sidebarTitle').focus();
          }
          this.utilService.showOrHideWindowPopup(dispIndatorObj[0].showWindowPopup);
        }
      }


    })

  }

}
